import * as React from 'react';
import PopoverDropdown, { PopoverDropdownItem } from '../PopoverDropdown/PopoverDropdown';

type Props = {
    items: PopoverDropdownItem[];
    iconClassName?: string;
    togglerClassName?: string;
};

const InlineDropdown = ({ items, iconClassName, togglerClassName }: Props) => (
    <PopoverDropdown
        toggler={<i className={iconClassName || 'fa fa-ellipsis-h'} color="link" />}
        togglerClassName={togglerClassName}
        items={items}
    />
);

export default InlineDropdown;
